import { Component } from '@angular/core';

@Component({
  selector: 'app-surface-finishing',
  templateUrl: './surface-finishing.component.html',
  styleUrls: ['./surface-finishing.component.scss']
})
export class SurfaceFinishingComponent {
  advanceMoullding:any[] = [
    {
      title: 'Painting',
      img: 'assets/images/capability/blue/surface_finishing_1.JPG',
    },
    {
      title: 'PUR Forming',
      img: 'assets/images/capability/blue/surface_finishing_2.JPG',
    },
    {
      title: 'Laminating',
      img: 'assets/images/capability/blue/surface_finishing_3.JPG',
    },
    {
      title: 'Decorative Services',
      img: 'assets/images/capability/blue/surface_finishing_3.JPG',
    },
    // {
    //   title: 'Sliding Head',
    //   img: 'assets/images/placeholder.jpg',
    // },
    // {
    //   title: 'Centreless Grinding​',
    //   img: 'assets/images/placeholder.jpg',
    // }
  ]

  produtimglist:any[] = [
    {
      img: 'assets/images/capability/blue/product-image-one.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-one.png',
    },    
  ]
  
  produtitemlist:any[] = [
    { 'item': 'Gear Rims'},
    { 'item': 'Heat Sinks'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'Pistons'},
    { 'item': 'Disc Valve / Port plate'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'Sleeve & Spool'},
    { 'item': 'Sub Assembly'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
  ]

  produtitemlistone:any[] = [
    { 'item': 'TiN'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'TiCN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'TiAlN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
  ]
  
  rawmaterial:any[] = [
    { 'item': '1–4-layer painting'},
    { 'item': 'Soft paint for parts'},
    { 'item': 'Water based and solvent based paints'},
  ]
  diamension:any[] = [
    { 'item': 'Thermo- and press lamination'},
    { 'item': 'Water based adhesive,'},
    { 'item': 'Thermoplastic or reactive hotmelt glue'},
    { 'item': 'Edge-folding equipment'},
  ]

  accuracy:any[] = [
     { 'item':'Superior softness'},
     { 'item':'Front foaming of plastic components for local softness'},
     { 'item':'High speed foam systems'},
     { 'item':'Automized and efficient carousel foam stations'},
    //  { 'item':'Roundness-1 micron'}
  ]

  surfacetreatment:any[] = [
    { 'item':'Textile fabric'},
    { 'item':'Leather'},
    { 'item':'Artificial leather'},
    { 'item':'Painted parts'},
    { 'item':'Metal PVD'},
    { 'item':'Decorative lamination'},
    { 'item':'Lighting Components'},
    { 'item':'Soft Touch Covers'},
 ]
}
